import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export default function UserAttendance() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAttendance = async () => {
      try {
        const res = await api.get("/user/attendance");
        setLogs(res.data);
      } catch (err) {
        console.error("Failed to load attendance", err);
      } finally {
        setLoading(false);
      }
    };

    loadAttendance();
  }, []);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (date) => {
    if (!date) return "-";

    const [timePart] = date.split("T")[1].split(".");
    let [hh, mm] = timePart.split(":");

    hh = parseInt(hh, 10);
    const suffix = hh >= 12 ? "PM" : "AM";
    if (hh > 12) hh -= 12;
    if (hh === 0) hh = 12;

    return `${hh}.${mm}${suffix}`;
  };

  function formatShiftTime(value) {
    if (!value) return "";

    const [h, m] = value.split(":").map(Number);

    if (h === 0) {
      return `${m}m`; // Only minutes
    }

    return `${h}h ${m}m`;
  }

  const getDuration = (punchIn, punchOut) => {
    if (!punchIn || !punchOut) return "-";

    const inTime = new Date(punchIn);
    const outTime = new Date(punchOut);
    const diffMs = outTime - inTime;

    if (diffMs <= 0) return "-";

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}m`;
  };

  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted fw-semibold">Loading attendance...</p>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Attendance</h2>

      <div
        className="shadow-sm p-4 rounded-4 bg-white mb-4"
        style={{ border: "1px solid #f1f1f1" }}
      >
        <table className="table align-middle">
          <thead className="table-light">
            <tr>
              <th className="fw-semibold">Date</th>
              <th className="fw-semibold">Punch In</th>
              <th className="fw-semibold">Punch Out</th>
              <th className="fw-semibold">Total Duration</th>
              <th className="fw-semibold">Late by</th>
              <th className="fw-semibold">Ealry by</th>
            </tr>
          </thead>
          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center py-4 text-muted">
                  No attendance records found.
                </td>
              </tr>
            ) : (
              logs.map((item, index) => (
                <tr key={index}>
                  <td className="fw-bold">{formatDate(item.date)}</td>
                  <td>{formatTime(item.punch_in)}</td>
                  <td>{formatTime(item.punch_out)}</td>
                  <td>{getDuration(item.punch_in, item.punch_out)}</td>
                  <td>{formatShiftTime(item.late_by) || "-"}</td>
                  <td>{formatShiftTime(item.early_by) || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
